import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { PRICE } from '../../data/checkout';
export function FinalCta() {
  return <section aria-labelledby="final-title" className="bg-charcoal py-16 sm:py-24" data-id="element-183" data-mp="22dcoa9yasl4d">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-5 text-center sm:px-8" data-id="element-184" data-mp="1no6ookvjssvy">
        <span className="block h-px w-12 bg-olive-light" aria-hidden data-id="element-185" data-mp="1smrowkasvcke" />
        <h2 id="final-title" className="mt-8 text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] text-ivory min-[390px]:text-[1.95rem] sm:text-[2.45rem] lg:text-[2.75rem]" data-id="element-186" data-mp="1ens11ev431pa">
          Your next furniture build starts with a plan.
        </h2>
        <p className="mt-4 text-[1.02rem] leading-relaxed text-parchment sm:text-[1.1rem]" data-id="element-187" data-mp="19ooyc12lt7kh">
          Get 60 furniture projects, six PDF volumes, and five bonus resources.
        </p>
        <CheckoutButton id="final-cta" label={`GET THE COLLECTION — ${PRICE.label}`} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-188" data-mp="342zlm53jvto5" />
      </div>
    </section>;
}